import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Mock Stripe Checkout — only ever rendered when STRIPE_MODE=mock on the
 * backend. Auto-marks the payment_transactions row as paid via finalize and
 * redirects to /signup/success (which then sets the JWT + lands on /portal).
 */
export default function MockCheckout() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const plan = searchParams.get("plan");
  const bins = searchParams.get("bins");
  const promo = searchParams.get("promo");
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const ranRef = useRef(false);

  // After 800ms, auto-redirect through finalize (simulates user paying)
  useEffect(() => {
    if (!sessionId || ranRef.current) return;
    ranRef.current = true;
    const t = setTimeout(() => navigate(`/signup/success?session_id=${sessionId}`), 600);
    return () => clearTimeout(t);
  }, [sessionId, navigate]);

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-slate-100 to-white flex items-center justify-center px-4 py-16"
      data-testid="page-mock-checkout"
    >
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-soft p-8 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center mb-4">
          <Loader2 className="h-6 w-6 text-slate-600 animate-spin" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-ink mb-1.5">
          Mock Stripe Checkout
        </h1>
        <p className="text-sm text-slate-600">
          Plan: <span className="font-semibold">{plan}</span> · {bins} bin{bins === "1" ? "" : "s"}
          {promo && (
            <>
              {" · "}
              <span className="font-semibold text-accent-700">{promo}</span>
            </>
          )}
        </p>
        <p className="text-xs text-slate-400 mt-4">
          Redirecting to /signup/success …
        </p>
        <div className="mt-6 inline-flex items-center gap-2 text-[11px] text-slate-500">
          <ShieldCheck size={12} className="text-accent" />
          STRIPE_MODE=mock · dev only
        </div>
      </div>
    </div>
  );
}
